export default (client) => ({
  get(id) {
    return client.request({
      method: 'get',
      url: `/fedex/${id}`,
    });
  },
  find(filterParams) {
    return client.request({
      method: 'get',
      url: '/fedex',
      params: { ...filterParams },
    });
  },
  create(payload) {
    return client.request({
      method: 'post',
      url: '/fedex',
      data: payload,
    });
  },
  patch(id, payload) {
    return client.request({
      method: 'put',
      url: `/fedex/${id}`,
      data: payload,
    });
  },
});
